/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { qrCodeAdminControllerCreateV1 } from '../fn/qr-code-admin/qr-code-admin-controller-create-v-1';
import { QrCodeAdminControllerCreateV1$Params } from '../fn/qr-code-admin/qr-code-admin-controller-create-v-1';
import { qrCodeAdminControllerDeleteV1 } from '../fn/qr-code-admin/qr-code-admin-controller-delete-v-1';
import { QrCodeAdminControllerDeleteV1$Params } from '../fn/qr-code-admin/qr-code-admin-controller-delete-v-1';
import { qrCodeAdminControllerDownloadQrCodeV1 } from '../fn/qr-code-admin/qr-code-admin-controller-download-qr-code-v-1';
import { QrCodeAdminControllerDownloadQrCodeV1$Params } from '../fn/qr-code-admin/qr-code-admin-controller-download-qr-code-v-1';
import { qrCodeAdminControllerFindByIdV1 } from '../fn/qr-code-admin/qr-code-admin-controller-find-by-id-v-1';
import { QrCodeAdminControllerFindByIdV1$Params } from '../fn/qr-code-admin/qr-code-admin-controller-find-by-id-v-1';
import { qrCodeAdminControllerSearchV1 } from '../fn/qr-code-admin/qr-code-admin-controller-search-v-1';
import { QrCodeAdminControllerSearchV1$Params } from '../fn/qr-code-admin/qr-code-admin-controller-search-v-1';
import { qrCodeAdminControllerUpdateV1 } from '../fn/qr-code-admin/qr-code-admin-controller-update-v-1';
import { QrCodeAdminControllerUpdateV1$Params } from '../fn/qr-code-admin/qr-code-admin-controller-update-v-1';
import { QrCodeDto } from '../models/qr-code-dto';

@Injectable({ providedIn: 'root' })
export class QrCodeAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `qrCodeAdminControllerSearchV1()` */
  static readonly QrCodeAdminControllerSearchV1Path = '/api/v1/qr-codes/admin';

  /**
   * QR코드 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qrCodeAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  qrCodeAdminControllerSearchV1$Response(params: QrCodeAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<QrCodeDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = qrCodeAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * QR코드 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qrCodeAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  qrCodeAdminControllerSearchV1(params: QrCodeAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<QrCodeDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.qrCodeAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<QrCodeDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<QrCodeDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `qrCodeAdminControllerCreateV1()` */
  static readonly QrCodeAdminControllerCreateV1Path = '/api/v1/qr-codes/admin';

  /**
   * QR코드 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qrCodeAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  qrCodeAdminControllerCreateV1$Response(params: QrCodeAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = qrCodeAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * QR코드 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qrCodeAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  qrCodeAdminControllerCreateV1(params: QrCodeAdminControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.qrCodeAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `qrCodeAdminControllerDownloadQrCodeV1()` */
  static readonly QrCodeAdminControllerDownloadQrCodeV1Path = '/api/v1/qr-codes/admin/download/{id}';

  /**
   * QR코드 이미지 다운로드.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qrCodeAdminControllerDownloadQrCodeV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  qrCodeAdminControllerDownloadQrCodeV1$Response(params: QrCodeAdminControllerDownloadQrCodeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = qrCodeAdminControllerDownloadQrCodeV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * QR코드 이미지 다운로드.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qrCodeAdminControllerDownloadQrCodeV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  qrCodeAdminControllerDownloadQrCodeV1(params: QrCodeAdminControllerDownloadQrCodeV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.qrCodeAdminControllerDownloadQrCodeV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `qrCodeAdminControllerFindByIdV1()` */
  static readonly QrCodeAdminControllerFindByIdV1Path = '/api/v1/qr-codes/admin/{id}';

  /**
   * QR코드 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qrCodeAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  qrCodeAdminControllerFindByIdV1$Response(params: QrCodeAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<QrCodeDto>> {
    const obs = qrCodeAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * QR코드 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qrCodeAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  qrCodeAdminControllerFindByIdV1(params: QrCodeAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<QrCodeDto> {
    const resp = this.qrCodeAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QrCodeDto>): QrCodeDto => r.body)
    );
  }

  /** Path part for operation `qrCodeAdminControllerDeleteV1()` */
  static readonly QrCodeAdminControllerDeleteV1Path = '/api/v1/qr-codes/admin/{id}';

  /**
   * QR코드 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qrCodeAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  qrCodeAdminControllerDeleteV1$Response(params: QrCodeAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = qrCodeAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * QR코드 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qrCodeAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  qrCodeAdminControllerDeleteV1(params: QrCodeAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.qrCodeAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `qrCodeAdminControllerUpdateV1()` */
  static readonly QrCodeAdminControllerUpdateV1Path = '/api/v1/qr-codes/admin/{id}';

  /**
   * QR코드 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qrCodeAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  qrCodeAdminControllerUpdateV1$Response(params: QrCodeAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = qrCodeAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * QR코드 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qrCodeAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  qrCodeAdminControllerUpdateV1(params: QrCodeAdminControllerUpdateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.qrCodeAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
